import { AmplifyGet } from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import { logger } from './logger';

const getInstallScheduleUrl = async (
  hybridToken: string,
  serviceAppointmentId: string | undefined,
) => {
  if (!serviceAppointmentId) {
    return undefined;
  }
  const response = await AmplifyGet<{
    self_scheduler_uuid: string;
  }>(
    'Get Install Schedule Url',
    'SalesExpDashboardApi',
    `/installScheduleUrl/${serviceAppointmentId}`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
    },
    logger,
    {
      expectedErrorCodes: [401, 403],
    },
  );
  return response.self_scheduler_uuid;
};

export { getInstallScheduleUrl };
